import React from 'react';
import { Col, Row } from 'reactstrap';

interface BreadCrumbProps {
    title: string;
    pageTitle: string;
    searchComponent?: React.ReactNode;
}

const BreadCrumb = ({ title, pageTitle, searchComponent }: BreadCrumbProps) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-flex align-items-center justify-content-between">

                        {/* Right side - Search Component (if provided) */}
                        {searchComponent && (
                            <div className="page-title-left">
                                {searchComponent}
                            </div>
                        )}

                        {/* Left side - Page Title */}
                        <div className="page-title-right">
                            <h4 className="mb-0 page-title">{title}</h4>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;